


























import { isEmpty } from 'lodash'
import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { defaultShopTypeOfSelectedTariff } from '../logic/helpers'
import { Getaway, Payment, SelectedShop, Shop, Tariff } from '../logic/types'
import CurrencySelect from './CurrencySelect.vue'
import GetawayList from './GetawayList.vue'

@Component({
  components: {
    GetawayList,
    CurrencySelect,
  },
  methods: {
    defaultShopTypeOfSelectedTariff,
  },
})
export default class MakePayment extends Vue {
  @Prop() readonly tariff!: Tariff

  @Prop() selectedShop!: SelectedShop

  @Prop({ type: Boolean, default: false }) multiplePayment!: boolean

  @Prop({ type: Function }) calcTotalFn!: (price: string, currencySymbol?: string, basePrice?: string) => number

  @Emit('updateGetaway')
  updateGetaway(getaway: Getaway): Getaway {
    return getaway
  }

  @Emit()
  generatePayment(): Payment | null {
    if (!this.isFormInvalid) {
      return {
        getaway: this.selectedGetaway as Getaway,
        tariff: this.tariff as Tariff,
        requiredFields: this.requiredFields,
      }
    }

    return null
  }

  @Watch('selectedShop')
  onShopSelect(): void {
    this.selectedGetaway = this.initialGetaway
  }

  @Watch('selectedGetaway')
  onSelectedGetawayChange(getaway: Getaway): void {
    this.updateGetaway(getaway)
  }

  selectedGetaway: Getaway | null = null

  requiredFields: any = null

  get initialGetaway(): Getaway | null {
    if (this.selectedShop) {
      return this.currentShop[0]
    }
    return null
  }

  get shops(): Tariff['shops'] {
    return this.tariff.shops
  }

  get currentShop() {
    if (this.selectedShop.group !== Shop.Global) {
      const nonGlobalShop = this.tariff.shops[this.selectedShop.group as Shop]

      if (nonGlobalShop) {
        return nonGlobalShop
      }
      return []
    } else {
      const globalShop = this.tariff.shops[Shop.Global]

      if (globalShop) {
        return globalShop.filter(s => s.currency_short_name === this.selectedShop.currency_short_name)
      }
    }

    return []
  }

  get sortedGetaways(): Array<Getaway> {
    if (this.currentShop.length) {
      return this.currentShop
        .slice()
        .sort((a: Getaway, b: Getaway) => b.weight - a.weight)
    }

    return []
  }

  get isFormInvalid(): boolean {
    if (this.selectedGetaway === null) return true

    return (!isEmpty(this.selectedGetaway.required) && this.requiredFields === null)
  }
}
